module.exports = __webpack_public_path__ + "img/lb.6b5ad081.png";